import React, { useCallback } from "react";
import { Parallax } from "react-scroll-parallax";
import "./Application.css";

import applyHero from "../assets/kidDandelion.webp";

function Application() {
  const handleScroll = useCallback(() => {
    const section = document.getElementById("online-application");
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="application-page">
      {/* Hero Section */}
      <Parallax speed={-10}>
        <div className="apply-hero" style={{ backgroundImage: `url(${applyHero})` }}>
          <div className="apply-hero-overlay"></div>
          <div className="apply-content">
            <h1 className="apply-title">Thank you for your interest in Binkley Preschool!</h1>
            <p className="apply-text">
              While we accept applications year-round, our initial enrollment period for the next school year begins in January. 
              Please see the application for more information. A child must be the age of the class for which he/she is applying by August 31 of the enrollment year.
            </p>
            <button className="apply-button" onClick={handleScroll}>
              View Application Process
            </button>
          </div>
        </div>
      </Parallax>

      {/* Application Sections */}
      <div className="application-wrapper">

        {/* Online Application */}
        <section className="online-application" id="online-application">
          <h2>Online Application</h2>
           <p>
            <span className="boldUppercase">
              To enroll online, please click the following link to fill out our online application!
            </span>
            <br /><br />
            Our enrollment period for the 2026-2027 school year opens on January 5, 2026.
            <br /><br />
            <span className="bold">Application Fee:</span>  $45 per application.
          </p> 
           <a
            href="https://schools.mybrightwheel.com/sign-in?redirect_path=/admissions/packet/24e088db-b14f-44c0-8b10-6d7e8cd54d30/fill?school_id=039a472a-c328-42b2-92ec-41607c69fcf8"
            target="_blank"
            rel="noopener noreferrer"
            className="application-link"
          >
            2026-2027 Online Application
          </a> 
        </section>

        {/* Paper Application */}
        {/* <section className="paper-application">
          <h2>Paper Application</h2> */}
          {/* <span className="boldUppercase">
            To enroll by paper, please click the link below to download, print, and fill out our application!
          </span>
          <p>
            <br />A completed application and a $40 non-refundable registration fee per child must be presented at the time of registration.
            <br /><br />
            Checks are payable to Binkley Preschool.
            <br /><br />
            Please mail the completed application and registration fee to:
          </p>
          <p className="address">
            <span className="boldLarge">Binkley Preschool</span>
            <br />
            1712 Willow Drive
            <br />
            Chapel Hill NC 27514
          </p> */}

          {/* <p>Applications for 2026-2027 coming soon!</p> */}
          {/* <a
            href="https://binkleypreschool.org/wp-content/uploads/BPS-Application-2025-2026.docx.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="application-link"
          >
            2025-2026 Paper Application
          </a> */}
        {/* </section> */}

      </div>
    </div>
  );
}

export default Application;
